export default {
  adapters: {
    breadcrumbs: {
      editorial: {
        home: 'Strona główna'
      },
      ugr: {
        home: 'Strona główna'
      },
      recipes: {
        home: 'Przepisy'
      }
    },
    cards: {
      userCollection: {
        // v4 plural
        savedItemDescription_one: 'element',
        savedItemDescription_few: 'elementy',
        savedItemDescription_many: 'elementów',
        savedItemDescription_other: 'elementów',
        // v3 plural
        savedItemDescription: 'element',
        savedItemDescription_plural: 'elementów',
        savedItemDescription_0: 'element',
        savedItemDescription_1: 'elementy',
        savedItemDescription_2: 'elementów'
      },
      userRecipe: {
        statusTextDraft: 'Szkic przepisu',
        statusApproved: 'Przepis użytkownika',
        statusPending: 'Oczekuje na zatwierdzenie',
        statusRejected: 'Przepis odrzucony'
      }
    },
    iconAdapter: {
      // v4 plural
      formatTimeHours_one: '{{hours}} godz.',
      formatTimeHours_few: '{{hours}} godz.',
      formatTimeHours_many: '{{hours}} godz.',
      formatTimeHours_other: '{{hours}} godz.',
      // v3 plural
      formatTimeHours: '{{hours}} godz.',
      formatTimeHours_plural: '{{hours}} godz.',
      formatTimeHours_0: '{{hours}} godz.',
      formatTimeHours_1: '{{hours}} godz.',
      formatTimeHours_2: '{{hours}} godz.',
      // v4 plural
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} min',
      formatTimeMins_many: '{{minutes}} min',
      formatTimeMins_other: '{{minutes}} min',
      // v3 plural
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} min',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} min',
      formatTimeMins_2: '{{minutes}} min'
    },
    pageSchema: {
      editorial: {
        recipe: {
          calories: '{{calories}} kalorii',
          carbContent: '{{carbs}} gram węglowodanów',
          fatContent: '{{fat}} gram tłuszczu',
          fibreContent: '{{fibre}} gram błonnika',
          proteinContent: '{{protein}} gram białka',
          satFatContent: '{{saturates}} gram tłuszczu nasyconego',
          sodiumContent: '{{sodium}} miligram sodu',
          sugarContent: '{{sugars}} gram cukru'
        }
      },
      ugr: {
        servesDefault: 'Dostarcza'
      }
    },
    post: {
      ugr: {
        messageMember: 'Przepis użytkownika',
        messageOther: 'Przepis {{status}}',
        statuses: {
          draft: 'draft',
          approved: 'zatwierdzony',
          rejected: 'usunięty',
          pending: 'oczekujący',
          published: 'opublikowany'
        }
      }
    },
    posts: {
      editorial: {
        list: {
          seeMoreText: 'Zobacz więcej'
        },
        liveBlog: {
          // v4 plural
          hour_one: 'godzinę temu',
          hour_few: 'godziny temu',
          hour_many: 'godzin temu',
          hour_other: 'godzin temu',
          // v3 plural
          hour: 'godzinę temu',
          hour_plural: 'godzin temu',
          hour_0: 'godzinę temu',
          hour_1: 'godziny temu',
          hour_2: 'godzin temu',
          // v4 plural
          lessThanHour_one: 'minutę temu',
          lessThanHour_few: 'minuty temu',
          lessThanHour_many: 'minut temu',
          lessThanHour_other: 'minut temu',
          // v3 plural
          lessThanHour: 'minutę temu',
          lessThanHour_plural: 'minut temu',
          lessThanHour_0: 'minutę temu',
          lessThanHour_1: 'minuty temu',
          lessThanHour_2: 'minut temu',
          lessThanMinute: 'mniej niż minutę temu',
          updatedMessageLive: 'Uaktualniane na żywo',
          updatedMessageNotLive: 'Uaktualnione'
        }
      },
      postAdapter: {
        callout: 'To jest {{status}} {{entity}}',
        previewCallout: 'Podgląd',
        recommendedTitle: 'Zobacz także',
        statuses: {
          draft: 'draft',
          approved: 'zatwierdzony',
          rejected: 'odrzucony',
          pending: 'nierozstrzygnięty',
          preview: 'podgląd',
          published: 'opublikowany'
        },
        entities: {
          glossary: 'słowniczek',
          howTo: 'w jaki sposób',
          editorialList: 'lista redakcyjna',
          plant: 'roślina',
          post: 'post',
          recipe: 'przepis',
          review: 'recenzja',
          'broadcast-show': 'program',
          venue: 'miejsce',
          page: 'strona',
          'user-collection': 'kolekcja użytkownika',
          blog: 'blog'
        }
      },
      recipeAdapter: {
        getPublicationMessage: 'Przepis od',
        labels: {
          carbs: 'carbs',
          fat: 'fat',
          fibre: 'fibre',
          protein: 'protein',
          salt: 'salt',
          saturates: 'saturates',
          sugars: 'sugars'
        },
        metricUnits: {
          tbsp: '{{count}}tbsp',
          tsp: '{{count}}tsp'
        },
        nutritionHighInPrefix: 'bogaty w',
        nutritionLabel: 'Wartości odżywcze:',
        nutritionLowInPrefix: 'ubogi w',
        nutritionLow: '_TODO: low',
        nutritionHigh: '_TODO: high',
        planning: {
          'easily-doubled': 'Łatwe zmniejszenie liczby porcji',
          'easily-halved': 'Łatwe zwiększenie liczby porcji',
          freezable: 'Odpowiednie do zamrażania'
        },
        recommendedAltTitle: 'Inne propozycje',
        servingsLabel_one: 'Dostarcza {{count}}',
        servingsLabel: 'Dostarcza {{count}}',
        servingsLabel_range: 'Dostarcza {{min}} - {{max}}'
      },
      userRecipeAdapter: {
        categoryDisplay: 'Przepisy'
      }
    },
    sponsorTracking: {
      label: 'Współpraca reklamowa'
    },
    pageBlocks: {
      riddle: {
        errorMessage: 'Wygląda na to, że wystąpił problem z quizem. Spróbuj ponownie.'
      }
    }
  },
  controllers: {
    archives: {
      taxonomyDataDisplayLabel: {
        age: 'Age',
        'date-of-birth': 'Date of birth',
        'comes-from': 'Comes from',
        'known-for': 'Known for',
        occupation: 'Occupation',
        'sign-of-the-zodiac': 'Sign of the Zodiac',
        parents: 'Parents',
        spouse: 'Spouse',
        biography: 'Biography'
      }
    },
    search: {
      modifyFilterOptions: {
        transform: {
          time: {
            // v4 plural
            hour_one: '{{hours}} godzinę',
            hour_few: '{{hours}} godziny',
            hour_many: '{{hours}} godzin',
            hour_other: '{{hours}} godzin',
            // v3 plural
            hour: '{{hours}} godzinę',
            hour_plural: '{{hours}} godzin',
            hour_0: '{{hours}} godzinę',
            hour_1: '{{hours}} godziny',
            hour_2: '{{hours}} godzin',
            // v4 plural
            minute_one: '{{minutes}} minutę',
            minute_few: '{{minutes}} minuty',
            minute_many: '{{minutes}} minut',
            minute_other: '{{minutes}} minut',
            // v3 plural
            minute: '{{minutes}} minutę',
            minute_plural: '{{minutes}} minut',
            minute_0: '{{minutes}} minutę',
            minute_1: '{{minutes}} minuty',
            minute_2: '{{minutes}} minut',
            gte: '{{time}} lub nieco dłużej',
            gt: 'Dłużej niż {{time}}',
            lte: '{{time}} lub nieco krócej',
            lt: 'Krócej niż {{time}}'
          },
          calories: {
            gteOrGt: 'Ponad {{calories}} kcal',
            lteOrLt: 'Do {{calories}} kcal'
          }
        }
      },
      siteSearchConfig: {
        facet: {
          label: {
            author: 'Autor',
            calories: 'Kalorie',
            category: 'Kategorie',
            cuisine: 'Kuchnie',
            diet: 'Dieta',
            difficulty: 'Trudność',
            mealType: 'Rodzaj dania',
            occasion: 'Okazje',
            ratings: 'Ratings',
            servings: 'Porcje',
            totalTime: 'Czas całkowity',
            allArticles: 'Wszystkie artykuły'
          }
        },
        filter: {
          label: {
            recipe: 'Przepisy',
            video: 'Wideo',
            guides: 'Przewodniki',
            collection: 'Kolekcje przepisów',
            glossary: 'Słowniczki',
            review: 'Recenzje'
          }
        },
        sortOptions: {
          label: {
            published: 'Najnowsze',
            quickest: 'Szybkie',
            rating: 'Najwyżej oceniane',
            relevant: 'Najistotniejsze'
          }
        }
      }
    }
  }
};